function initSlideshows() {
    document.querySelectorAll('[data-slideshow]').forEach((slideshow) => {
        const slides = [...slideshow.querySelectorAll('.slideshow__slide')];
        const dots = [...slideshow.querySelectorAll('.slideshow__dot')];
        let currentIndex = 0;
        let timer;

        if (slides.length < 2) return;

        function showSlide(index) {
            currentIndex = index;

            slides.forEach((slide, slideIndex) => {
                const isActive = slideIndex === currentIndex;
                slide.classList.toggle('is-active', isActive);
                slide.setAttribute('aria-hidden', String(!isActive));
            });

            dots.forEach((dot, dotIndex) => {
                const isActive = dotIndex === currentIndex;
                dot.classList.toggle('is-active', isActive);
                dot.setAttribute('aria-current', String(isActive));
            });

            clearTimeout(timer);
            const duration = Number(slides[currentIndex].dataset.duration) || 5;
            timer = setTimeout(() => showSlide((currentIndex + 1) % slides.length), duration * 1000);
        }

        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => showSlide(index));
        });

        showSlide(0);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshows);
} else {
    initSlideshows();
}
